import React from "react";
import urls from "../../../constants";

const HIDDEN_VARIANT_IDS = [8, 12, 13, 14, 15];

const TableHeader = ({ productConfigVariant }) => {
    return (
        <thead>
            <tr>
                {productConfigVariant
                    ?.filter((item) =>
                        !urls?.HIDDEN_FIELDS_GROUP?.includes(item?.groupId) &&
                        !HIDDEN_VARIANT_IDS.includes(item?.variantId)
                    )
                    .sort((a, b) => (a?.sequence ?? 0) - (b?.sequence ?? 0))
                    .map((item, index) => {
                    return (
                        <th key={item?.variantId ?? index}>
                            {item?.variantName}
                        </th>
                    );
                })}
                <th>Unit Price</th>
                <th>CO Qty</th>
                <th>Released <br/> Qty</th>
                <th>Current Release</th>
                <th>Margin(+) /
                 <br/> Discount(-)</th>
                <th>Total Price</th>
                <th>Notes</th>
                <th>Req Dely Date</th>
            </tr>
        </thead>
    );
};
export default TableHeader
